import { useContext } from "react";
import { ProfileContext } from "../profile/ProfileContext";
import type { ProfileState } from "../profile/ProfileContext";

export function useGymProfile(): ProfileState {
  const ctx = useContext(ProfileContext);
  if (ctx === undefined) {
    throw new Error("useGymProfile must be used inside <ProfileProvider>");
  }
  return ctx;
}
